import { useGetBusinessesQuery } from '@/pages/Fleet/Businesses/services/businesses.service';

type UseBusinessesProps = {
  search?: string;
  page: number;
  pageSize: number;
};

const useBusinesses = ({ search, page, pageSize }: UseBusinessesProps) => {

  const { data, isLoading, error } = useGetBusinessesQuery({ search, paginated: { page, pageSize } });

  return {
    isLoading, error,
    businesses: data?.items || [],
    totalItems: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
  };

};

export default useBusinesses;
